import { Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import formatCurrency from "helpers/formatCurrency";
import moment from "moment";

export default function getReadingsTableData(readings, setReadingImage) {
  const Reading = ({ reading }) => (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography display="block" variant="caption" color="text" fontWeight="medium">
        {reading}
      </MDTypography>
    </MDBox>
  );

  return {
    columns: [
      { Header: "Date", accessor: "date", align: "left" },
      { Header: "Reading", accessor: "reading", align: "left" },
      { Header: "Units Consumed", accessor: "units", align: "center", minWidth: "100px" },
      { Header: "Calculation", accessor: "calculation", align: "center" },
      { Header: "Charge", accessor: "charge", align: "right" },
      { Header: "Image", accessor: "image", align: "center" },
    ],

    rows: readings.map((reading) => {
      return {
        date: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {moment(reading.createdAt).format("YY/MM/DD")}
          </MDTypography>
        ),
        reading: <Reading reading={reading.current_reading} />,
        units: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {reading.units}
          </MDTypography>
        ),
        calculation: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {reading.calculation}
          </MDTypography>
        ),
        charge: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {formatCurrency(reading.price)}
          </MDTypography>
        ),
        image: (
          <Icon
            style={{
              cursor: reading.image_url ? "pointer" : "auto",
              color: reading.image_url ? "#1A73E8" : "gray",
            }}
            onClick={
              reading.image_url
                ? () => {
                    setReadingImage(reading.image_url);
                  }
                : null
            }
          >
            visibility
          </Icon>
        ),
      };
    }),
  };
}
